import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import {
  Avatar,
  Box,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material';
import { CSSProperties, FC } from 'react';

import { UserMin } from '@apiContract';

import {
  sxAvatar,
  sxCheckOutIcon,
  sxItemAvatar,
  sxItemButton,
  sxLocationBox,
  sxSelectedBox,
} from '../../styles';
import { sxCutText } from 'src/theme/shared/styles';

type ListItemProps = {
  selected: boolean;
  style: CSSProperties;
  user: UserMin | null;
  index: number;
};

const AllUsersItem: FC<ListItemProps> = ({ style, selected, user, index }) => {
  const theme = useTheme();

  if (!user) {
    return null;
  }

  return (
    <ListItem component="div" sx={style} disablePadding data-userindex={index} >
      <ListItemButton sx={{ ...sxItemButton(selected, false, theme) }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" flex={1} sx={{ minWidth: 0 }}>
          <ListItemAvatar sx={sxItemAvatar}>
            <Avatar sx={sxAvatar} alt={`${user.firstName} ${user.lastName}`} src={user.profileImageUrl}>
              {user?.firstName?.charAt(0)}
              {user?.lastName?.charAt(0)}
            </Avatar>
            {selected ? (
              <Box sx={sxSelectedBox}>
                <CheckOutlinedIcon sx={sxCheckOutIcon} />
              </Box>
            ) : null}
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography
                title={user.displayName}
                variant="subtitle2"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                overflow="hidden"
              >
                {user.displayName}
              </Typography>
            }
            secondary={
              <Typography
                title={user?.userName}
                color="text.secondary"
                variant="body2"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                overflow="hidden"
              >
                {user?.userName}
              </Typography>
            }
          />
        </Box>
        <Box sx={sxLocationBox}>
          {user.locationName && (
            <Typography
              title="user.locationName"
              color="text.secondary"
              variant="body2"
              textAlign="right"
              sx={sxCutText}
            >
              {user.locationName}
            </Typography>
          )}
        </Box>
      </ListItemButton>
    </ListItem>
  );
};

export default AllUsersItem;
